import Script from 'next/script';
import React from 'react';
import pendoScript from '../../../lib/util/pendo';

/**
 * Pendo script.
 */
const PendoScript = () => {
  if (!process.env.NEXT_PUBLIC_PENDO_API_KEY) return null;
  return (
    <Script
      id="pendoScript"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{
        __html: pendoScript(process.env.NEXT_PUBLIC_PENDO_API_KEY),
      }}
    />
  );
};

export default PendoScript;
